<template>
    <div class="card border-0 h-100">
        <div class="card-body">
            <h3 class="text-left mb-4 border-bottom p-2">{{ heading }}</h3>
            <div v-if="data1.name" class="row pr-md-4 pl-md-3">
                <div
                    class="col-4 col-md-3 col-lg-2 bg-secondary text-center py-2 d-flex align-items-center justify-content-center rounded">
                    <h1 class="font-weight-bolder m-0">{{ data1.value }}</h1>
                </div>
                <div class="col-8 col-md-9 col-lg-10">
                    <h4 class="mb-0">{{ data1.name }}</h4>
                    <small class="data-description text-muted d-block">{{ data1.description }}</small>
                </div>
            </div>
            <hr>
            <div v-if="data2.name" class="row pr-md-4 pl-md-3">
                <div
                    class="col-4 col-md-3 col-lg-2 bg-secondary text-center py-2 d-flex align-items-center justify-content-center rounded">
                    <h1 class="font-weight-bolder m-0">{{ data2.value }}</h1>
                </div>
                <div class="col-8 col-md-9 col-lg-10">
                    <h4 class="mb-0">{{ data2.name }}</h4>
                    <small class="data-description text-muted d-block">{{ data2.description }}</small>
                </div>
            </div>
            <hr>
            <div v-if="data3.name" class="row pr-md-4 pl-md-3">
                <div
                    class="col-4 col-md-3 col-lg-2 bg-secondary text-center py-2 d-flex align-items-center justify-content-center rounded">
                    <h1 class="font-weight-bolder m-0">{{ data3.value }}</h1>
                </div>
                <div class="col-8 col-md-9 col-lg-10">
                    <h4 class="mb-0">{{ data3.name }}</h4>
                    <small class="data-description text-muted d-block">{{ data3.description }}</small>
                </div>
            </div>
            <div v-if="!data3.name" class="mb-7"></div>
        </div>
    </div>
</template>
<script>
export default {
    name: "CardData",
    props: {
        heading: { type: String, default: "" },
        data1: { type: Object, default: {} },
        data2: { type: Object, default: {} },
        data3: { type: Object, default: {} },
        data4: { type: Object, default: {} },
    },
};
</script>